import { motion } from "framer-motion";
import { ArrowUpRight, ShieldCheck, Wrench, Zap } from "lucide-react";

const SERVICES = [
  { id: "service-rental-card", num: "01", icon: Zap, title: "DG Set Rental", text: "Daily, weekly and long-term hiring for sites, events, offices and factories — 15 to 500 kVA.", link: ["#fleet", "Explore the fleet"] },
  { id: "service-maintenance-card", num: "02", icon: Wrench, title: "Maintenance & AMC", text: "Preventive servicing, emergency repairs and annual contracts that protect your uptime.", link: ["#maintenance", "Our approach"] },
  { id: "service-support-card", num: "03", icon: ShieldCheck, title: "On-site Support", text: "Delivery, installation, fuel guidance and a phone that is actually answered, around the clock.", link: ["#booking", "Talk to our team"] },
];

export const Services = () => (
  <section id="services" className="section">
    <div className="sec-head">
      <div>
        <p className="eyebrow">WHAT WE DO</p>
        <h2 className="sec-title">Power without<br /><em>the pause.</em></h2>
      </div>
      <p className="sec-sub">From a compact site setup to an industrial-scale operation, we keep your work moving with dependable machines and people who know them inside out.</p>
    </div>
    <div className="svc-grid">
      {SERVICES.map((s, i) => (
        <motion.article key={s.id} data-testid={s.id} className="svc-card"
          initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: i * 0.12, ease: [0.76, 0, 0.24, 1] }}>
          <span className="svc-num">{s.num}</span>
          <s.icon className="svc-icon" size={30} strokeWidth={1.2} />
          <h3>{s.title}</h3>
          <p>{s.text}</p>
          <a href={s.link[0]}>{s.link[1]} <ArrowUpRight size={14} /></a>
        </motion.article>
      ))}
    </div>
  </section>
);
